import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import '@npm-bbta/bbog-dig-dt-webcomponents-lib';
import WebcomponentParam from '../models/webcomponent-param';
import { environment } from '../../../environments/environment';
import { SecondFactorTitleEnum } from './models/second-factor-title-enum';
import { SecondFactorIconEnum } from './models/second-factor-icon-enum';
import { Router } from '@angular/router';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { CustomerStatesEnum } from '../shared/models/enum/CustomerStatesEnum';

@Component({
    selector: 'app-bdb-second-factor-selector',
    templateUrl: './bdb-second-factor-selector.component.html',
    styleUrls: ['./bdb-second-factor-selector.component.scss']
})
export class BdbSecondFactorSelectorComponent implements OnInit {

    @ViewChild('bdbMlMultiActionElement') bdbMlMultiAction: ElementRef;


    constructor(
        private readonly router: Router,
        private readonly bdbSessionStorageService: BdbSessionStrgService
    ) {
    }

    private getWebComponentsParams(): WebcomponentParam[] {
        const webComponentsParamsArray = [];
        const secondFactorsArray = [];
        let id = 0;
        const customerState = this.bdbSessionStorageService.get(SessionStorageKeysEnum.CUSTOMER_STATE);
        const clientType = customerState.toLowerCase();
        const secondFactors = this.bdbSessionStorageService.get(SessionStorageKeysEnum.SECOND_FACTORS) ? this.bdbSessionStorageService.get(SessionStorageKeysEnum.SECOND_FACTORS)[clientType] : null;
        const isClient = clientType === 'active';
        if (environment.useSecurePassword && isClient) {
            id++;
            const webComponentParam = new WebcomponentParam(
                String(id),
                SecondFactorTitleEnum.securePassword,
                null,
                SecondFactorIconEnum.securePassword,
            );
            webComponentsParamsArray.push(webComponentParam);
        }
        if (environment.useDebitCardPassword && isClient) {
            id++;
            const webComponentParam = new WebcomponentParam(
                String(id),
                SecondFactorTitleEnum.debitCardPassword,
                null,
                SecondFactorIconEnum.debitCardPassword,
            );
            webComponentsParamsArray.push(webComponentParam);
        }
        if (environment.useToken && isClient) {
            id++;
            const webComponentParam = new WebcomponentParam(
                String(id),
                SecondFactorTitleEnum.token,
                null,
                SecondFactorIconEnum.token,
            );
            webComponentsParamsArray.push(webComponentParam);
        }
        if (environment.useConfronta) {
            id++;
            const webComponentParam = new WebcomponentParam(
                String(id),
                SecondFactorTitleEnum.questions,
                null,
                SecondFactorIconEnum.questions
            );
            webComponentsParamsArray.push(webComponentParam);
        }
        for (const factor in secondFactors) {
            if (secondFactors[factor]) {
                id++;
                const webComponentParam = new WebcomponentParam(
                    String(id),
                    SecondFactorTitleEnum[factor],
                    null,
                    SecondFactorIconEnum[factor],
                );
                secondFactorsArray.push(webComponentParam);
            }
        }
        const values = secondFactorsArray.length > 1 ? secondFactorsArray : webComponentsParamsArray;
        return values;
    }

    ngOnInit() {
        console.log('Web Components Params: ', this.getWebComponentsParams());
    }

    selectedCard(event: any): void {
        const detail = event.detail;
        const optionSelected = detail.desc;
        switch (optionSelected) {
            case SecondFactorTitleEnum.debitCardPassword:
                console.log(optionSelected);
                this.router.navigate(['debit-card-password']);
                break;
            case SecondFactorTitleEnum.token:
                console.log(optionSelected);
                this.router.navigate(['token']);
                break;
            case SecondFactorTitleEnum.securePassword:
                console.log(optionSelected);
                this.router.navigate(['secure-password']);
                break;
            case SecondFactorTitleEnum.questions:
                console.log(optionSelected);
                this.router.navigate(['cifin-confronta']);
                break;
            default:
                console.error('No action found for selected option');
        }
    }

    closeButtonClicked(event: any): void {
        this.router.navigate(['identity-number']);
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-second-factor-selector/bdb-second-factor-selector.component.ts